import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "./leafletGlobal";
import "leaflet.heat";

const GRADIENT = { 0.15: "#0ea5e9", 0.35: "#10b981", 0.55: "#facc15", 0.75: "#f97316", 1: "#ef4444" };

export default function HeatLayer({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return undefined;
    const max = Math.max(...points.map((p) => p[2]));
    const layer = L.heatLayer(
      points.map(([lat, lng, w]) => [lat, lng, w / max]),
      { radius: 50, blur: 28, maxZoom: 13, minOpacity: 0.55, max: 0.7, gradient: GRADIENT },
    ).addTo(map);
    return () => { map.removeLayer(layer); };
  }, [map, points]);
  return null;
}
